import React from 'react';
import '../styles/DetailsModal.css';

interface DetailsModalProps {
  message: string;
  onClose: () => void;
}

const DetailsModal: React.FC<DetailsModalProps> = ({ message, onClose }) => {
  return (
    <div className="details-modal-overlay" onClick={onClose}>
      <div className="details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="details-modal-header">
          <h3>Λεπτομέρειες</h3>
          <button className="details-close-btn" onClick={onClose}>×</button>
        </div>
        <div className="details-modal-content">
          <p>{message}</p>
        </div>
        <div className="details-modal-footer">
          <button className="details-ok-btn" onClick={onClose}>
            Κλείσιμο
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;
